// extracted by css-extract-rspack-plugin
export default {"dark":"product-detail-fragment__LocationFilterComponent_dark__lic7U","rangeHeader":"product-detail-fragment__LocationFilterComponent_rangeHeader__pzioq"};